import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { designationAction as actions, notificationActions } from '../actions';
import { designationService } from '../services';

/* Add Designation Sagas */
function* handleAddDesignationRequest() {
  const action = yield take(actions.addDesignationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(designationService.addDesignation, dataParams);
    if (res.isError) {
      yield put(actions.addDesignationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addDesignationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addDesignationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All Designation Sagas */
function* handleGetAllDesignationRequest() {
  const action = yield take(actions.getAllDesignationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(designationService.getAllDesignation, dataParams);
    if (res.isError) {
      yield put(actions.getAllDesignationError(res));

    } else {
      yield put(actions.getAllDesignationSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllDesignationError());
  }
}

/* Get Designation By Department Sagas */
function* handleGetDesignationsByDepartmentRequest() {
  const action = yield take(actions.getDesignationsByDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(designationService.getDesignationsByDepartment, dataParams);
    if (res.isError) {
      yield put(actions.getDesignationsByDepartmentError(res));

    } else {
      yield put(actions.getDesignationsByDepartmentSuccess(res));
    }

  } catch (error) {
    yield put(actions.getDesignationsByDepartmentError());
  }
}

/* Update Designation Sagas */
function* handleUpdateDesignationRequest() {
  const action = yield take(actions.updateDesignationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(designationService.updateDesignation, dataParams);
    if (res.isError) {
      yield put(actions.updateDesignationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateDesignationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateDesignationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Designation Sagas */
function* handleDeleteDesignationRequest() {
  const action = yield take(actions.deleteDesignationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(designationService.deleteDesignation, dataParams);
    if (res.isError) {
      yield put(actions.deleteDesignationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteDesignationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteDesignationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* -----------Watchers------------- */
function* handleAddDesignationWatcher() {
  yield takeEvery(
    actions.addDesignationRequest,
    handleAddDesignationRequest,
  );
}

function* handleGetAllDesignationWatcher() {
  yield takeEvery(
    actions.getAllDesignationRequest,
    handleGetAllDesignationRequest,
  );
}

function* handleGetDesignationsByDepartmentWatcher() {
  yield takeEvery(
    actions.getDesignationsByDepartmentRequest,
    handleGetDesignationsByDepartmentRequest,
  );
}

function* handleUpdateDesignationWatcher() {
  yield takeEvery(
    actions.updateDesignationRequest,
    handleUpdateDesignationRequest,
  );
}

function* handleDeleteDesignationWatcher() {
  yield takeEvery(
    actions.deleteDesignationRequest,
    handleDeleteDesignationRequest,
  );
}



function* rootDesignationSaga() {
  yield all([
    handleAddDesignationRequest(),
    handleAddDesignationWatcher(),

    handleGetAllDesignationRequest(),
    handleGetAllDesignationWatcher(),

    handleGetDesignationsByDepartmentRequest(),
    handleGetDesignationsByDepartmentWatcher(),

    handleUpdateDesignationRequest(),
    handleUpdateDesignationWatcher(),

    handleDeleteDesignationRequest(),
    handleDeleteDesignationWatcher(),
  ]);
}

export default rootDesignationSaga;
